import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { User } from 'src/app/models/users.model';
import { CountryCode } from 'src/app/models/country.enum';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { COUNTRY_OPTIONS, CountryOption } from '../../constants';

@Component({
  selector: 'app-country-select',
  templateUrl: './country-select.component.html',
  styleUrls: ['./country-select.component.scss'],
})
export class CountrySelectComponent implements OnInit {
  user: User;
  countryOptions = COUNTRY_OPTIONS;

  selectedCountry = this.countryOptions[0];

  constructor(
    private ss: SharedService,
    private afs: AngularFirestore,
  ) {}

  async ngOnInit() {
    this.user = await this.ss.getUser();
    if (!this.user.countryCode) {
      this.countrySelected(this.countryOptions.find((a) => a.code === CountryCode.ZA));
    }
    this.selectedCountry = this.countryOptions.find((a) => a.code === this.user.countryCode);
  }

  async countrySelected(option: CountryOption) {
    this.user.countryCode = option.code;
    await this.afs.doc<User>(`users/${this.user.uid}`).update({
      countryCode: option.code,
    });
  }
}
